module.exports = __webpack_public_path__ + "static/img/example.68bd9f77.svg";